/**
 * Web shim for expo-secure-store
 *
 * expo-secure-store is native-only (Keychain/Keystore). On web, callers
 * already branch on Platform.OS and use localStorage instead. This shim
 * lets Metro resolve the import without pulling in native code.
 */

module.exports = {
  __esModule: true,
  getItemAsync: async () => null,
  setItemAsync: async () => {},
  deleteItemAsync: async () => {},
  isAvailableAsync: async () => false,
  AFTER_FIRST_UNLOCK: 0,
  AFTER_FIRST_UNLOCK_THIS_DEVICE_ONLY: 1,
  ALWAYS: 2,
  ALWAYS_THIS_DEVICE_ONLY: 3,
  WHEN_PASSCODE_SET_THIS_DEVICE_ONLY: 4,
  WHEN_UNLOCKED: 5,
  WHEN_UNLOCKED_THIS_DEVICE_ONLY: 6,
};

module.exports.default = module.exports;
